// Typsecript seems to have trouble to infer literals of paginated response with mockedRequester
export const mockedPaginatedResponse = (results) => ({
    count: results.length,
    next: null,
    previous: null,
    results
});
export default mockedPaginatedResponse;
